/**
 * Who signed a check-in, for display. An office row (Sales' office tool records a
 * return or check-out nobody scanned) has no signer and reads "Recorded by office".
 * Accepts the raw API row (snake_case) or the unit-section DTO (camelCase).
 */
export const OFFICE_ENTRY_LABEL = 'Recorded by office';

interface SignerFields {
  driver_first_name?: string | null;
  driver_last_name?: string | null;
  entry_source?: string | null;
  driverFirstName?: string | null;
  driverLastName?: string | null;
  entrySource?: string | null;
}

export function checkinSignerName(c: SignerFields): string {
  if ((c.entry_source ?? c.entrySource) === 'office') return OFFICE_ENTRY_LABEL;
  return [c.driver_first_name ?? c.driverFirstName, c.driver_last_name ?? c.driverLastName].filter(Boolean).join(' ');
}
